import { render, staticRenderFns } from "./InformacionTab.vue?vue&type=template&id=3b4a1b2e"
import script from "./InformacionTab.vue?vue&type=script&lang=js"
export * from "./InformacionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports